export default __webpack_public_path__ + "maps-examples-simple-map-view-960-8af8f861fd99410f9465051449daaf22.webp";